export default {
    Search: 'Найти',
    'No results found.': 'Ничего не найдено.',
    cancel: 'отменить'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/searchfield/translations/ru.js
// module id = 483
// module chunks = 0